import { createAction, props } from '@ngrx/store';
import { AssignmentApiModel } from 'app/models/assignment-api.model';

export const updateDeliveriesPageFilter = createAction(
  '[PageFilter Settings] Update deliveries page filter',
  props<{ deliveriesPage: AssignmentApiModel }>()
);

export const resetDeliveriesPageFilter = createAction(
  '[PageFilter Settings] Reset delivery page filter'
);
